<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-list-legacy [listItems]="items" ltype="multi" designVar="s12" [mconfig]="viewId || travelBillToolbar ? menu : undefined" [typevar]="navigateRows ? 'g' : undefined" [ttRowClick]="rowClick"></tt-list-legacy>
